import { NgModule, Inject, PLATFORM_ID, APP_ID, LOCALE_ID } from '@angular/core';
import { isPlatformBrowser, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { TransferHttpCacheModule } from '@nguniversal/common';

import { JwtModule } from '@auth0/angular-jwt';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeHu from '@angular/common/locales/hu';
// import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";

import { environment } from '@app-env/environment';

import { extModules } from './build-specifics';

import { CoreModule } from '@app-core/core.module';
import { SharedModule } from '@app-shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

registerLocaleData(localeHu, 'hu');

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
	// return new TranslateHttpLoader(http, environment.API_URL + 'translation/', ''); // `?${environment.COMMIT_HASH.substring(0, 8)}`
	return new TranslateHttpLoader(http, '/assets/i18n/', `.json?${environment.COMMIT_HASH.substring(0, 8)}`);
}

export function tokenGetter() {
	return localStorage.getItem('access_token');
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'website' }),
		TransferHttpCacheModule,

		HttpClientModule,

		JwtModule.forRoot({
			config: {
				tokenGetter,
				allowedDomains: ['ecsomaghu.staging.moonproject.io'],
			},
		}),

		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
			defaultLanguage: 'hu',
			useDefaultLang: true,
		}),

		AppRoutingModule,
		CoreModule,
		SharedModule,

		extModules,
	],
	providers: [{ provide: LOCALE_ID, useValue: 'hu' }],
})
export class AppModule {
	constructor(@Inject(PLATFORM_ID) platformId: object, @Inject(APP_ID) appId: string) {
		const platform = isPlatformBrowser(platformId) ? 'in the browser' : 'on the server';
		console.log(`Running ${platform} with appId=${appId}`);
	}
}
